import { useState } from "react";
import _ from "lodash";

import { Accordion, Button, Col, Form, Row } from "react-bootstrap";

import { datenanforderKacheln } from "./globalVariables";
import DatePicker from "react-datepicker";

export default function Stapelverarbeitung({
   user,
   userlist,
   resetData,
   datenblattkacheln,
   projektstufe,
   sendData,
   editMultipleKachel,
   eskstatus,
}) {
   const [stapeldaten, setStapeldaten] = useState({});
   const [eskDaten, setEskDaten] = useState({});
   const [selectedKacheln, setSelectedKacheln] = useState({});
   const [isEdited, setIsEdited] = useState(false);

   return (
      <>
         <Accordion className="mb-3">
            <Accordion.Item eventKey="0">
               <Accordion.Header ><h2 className="ms-4">Stapelverarbeitung</h2></Accordion.Header>
               <Accordion.Body>
                  <div
                     style={{
                        padding: "20px 28px",
                        border: "solid 1px #ddd",
                        boxShadow: "0 0 16px #bbb",
                        borderRadius: "8px",
                        marginTop: "16px",
                     }}
                  >
                     <Form>
                        <div className={isEdited ? "disabled-form" : ""}>
                           <Row>
                              <div className="col" style={{ position: "relative" }}>
                                 <Form.Group as={Col} controlId={"id_am"} className="mb-3">
                                    <Form.Label>angefordert am</Form.Label>

                                    <DatePicker
                                       selected={
                                          stapeldaten.anforderdatum && stapeldaten.anforderdatum != "0000-00-00"
                                             ? new Date(stapeldaten.anforderdatum)
                                             : false
                                       }
                                       showTimeSelect
                                       timeIntervals={5}
                                       onChange={(e) =>
                                          setStapeldaten((prev) => ({
                                             ...prev,
                                             anforderdatum: e,
                                          }))
                                       }
                                       className={"bootstrap-datepicker"}
                                       calendarClassName="custom-date-calendar"
                                       timeFormat="HH:mm"
                                       dateFormat="dd.MM.yyyy, HH:mm"
                                       popperPlacement="bottom"
                                       locale="de"
                                    />
                                 </Form.Group>
                                 <button
                                    type="button"
                                    title="heute und jetzt als Datum einstellen"
                                    className="now-button"
                                    onClick={(e) => {
                                       setStapeldaten((prev) => ({
                                          ...prev,
                                          anforderdatum: new Date(),
                                       }));
                                    }}
                                 >
                                    {"˅"}
                                 </button>{" "}
                              </div>

                              <Form.Group as={Col} controlId={"id_von"} className="mb-3">
                                 <Form.Label>angefordert von</Form.Label>

                                 <Form.Select
                                    onChange={(e) =>
                                       setStapeldaten((prev) => ({
                                          ...prev,
                                          [e.target.name]: e.target.value,
                                       }))
                                    }
                                    name="anforderperson"
                                    value={stapeldaten.anforderperson ? stapeldaten.anforderperson : ""}
                                 >
                                    <option value=""></option>
                                    <option value={user.Name}>
                                       {user.Vorname} {user.Nachname}
                                    </option>
                                    {userlist &&
                                       userlist.map((user, index) => (
                                          <option key={"selectuser_" + user.Name} value={user.Name}>
                                             {user.Nachname + " " + user.Vorname}
                                          </option>
                                       ))}
                                 </Form.Select>
                              </Form.Group>

                              <Form.Group as={Col} controlId={"id_bei"} className="mb-3">
                                 <Form.Label>angefordert bei</Form.Label>
                                 {(stapeldaten.anforder_bei ? stapeldaten.anforder_bei : "") !== "" &&
                                 (stapeldaten.anforder_bei === " " ||
                                    ["Eigentümer", "Verwaltung", "Sonstiges"].indexOf(stapeldaten.anforder_bei) ===
                                       -1) ? (
                                    <Form.Control
                                       onChange={(e) =>
                                          setStapeldaten((prev) => ({
                                             ...prev,
                                             [e.target.name]: e.target.value,
                                          }))
                                       }
                                       name="anforder_bei"
                                       value={stapeldaten.anforder_bei}
                                    />
                                 ) : (
                                    <>
                                       <Form.Select
                                          name={"anforder_bei"}
                                          onChange={(e) =>
                                             setStapeldaten((prev) => ({
                                                ...prev,
                                                [e.target.name]: e.target.value,
                                             }))
                                          }
                                          value={stapeldaten.anforder_bei ? stapeldaten.anforder_bei : "blabla"}
                                       >
                                          <option value=""></option>
                                          {["Eigentümer", "Verwaltung", "Sonstiges"].map((option, index) => (
                                             <option
                                                key={"select_" + option}
                                                value={option === "Sonstiges" ? " " : option}
                                             >
                                                {option}
                                             </option>
                                          ))}
                                       </Form.Select>
                                    </>
                                 )}
                              </Form.Group>
                           </Row>
                           <Row>
                              <div className="col" style={{ position: "relative" }}>
                                 <Form.Group as={Col} controlId={"id_am"} className="mb-3">
                                    <Form.Label title="wird auf das maximale Eskalationsdatum begrenzt">
                                       Eskalationsdatum*
                                    </Form.Label>

                                    <DatePicker
                                       selected={
                                          eskDaten.kachel_eskalation && eskDaten.kachel_eskalation != "0000-00-00"
                                             ? new Date(eskDaten.kachel_eskalation)
                                             : false
                                       }
                                       showTimeSelect
                                       timeIntervals={5}
                                       onChange={(e) =>
                                          setEskDaten((prev) => ({
                                             ...prev,
                                             kachel_eskalation: e,
                                          }))
                                       }
                                       className={"bootstrap-datepicker"}
                                       calendarClassName="custom-date-calendar"
                                       timeFormat="HH:mm"
                                       dateFormat="dd.MM.yyyy, HH:mm"
                                       popperPlacement="bottom"
                                       locale="de"
                                    />
                                 </Form.Group>
                                 <button
                                    title="heute und jetzt als Datum einstellen"
                                    className="now-button"
                                    type="button"
                                    onClick={(e) =>
                                       setEskDaten((prev) => ({
                                          ...prev,
                                          kachel_eskalation: new Date(),
                                       }))
                                    }
                                 >
                                    {"˅"}
                                 </button>{" "}
                              </div>
                              {["globaladmin","admin", "editor","user"].includes(user.role) && (
                                 <div className="col" style={{ position: "relative" }}>
                                    <Form.Group as={Col} controlId={"id_am"} className="mb-3">
                                       <Form.Label>(Admin) Max-Eskalationsdatum</Form.Label>

                                       <DatePicker
                                          selected={
                                             eskDaten.kachel_max_eskalation &&
                                             eskDaten.kachel_max_eskalation != "0000-00-00"
                                                ? new Date(eskDaten.kachel_max_eskalation)
                                                : false
                                          }
                                          showTimeSelect
                                          timeIntervals={5}
                                          onChange={(e) =>
                                             setEskDaten((prev) => ({
                                                ...prev,
                                                kachel_max_eskalation: e,
                                             }))
                                          }
                                          className={"bootstrap-datepicker"}
                                          calendarClassName="custom-date-calendar"
                                          timeFormat="HH:mm"
                                          dateFormat="dd.MM.yyyy, HH:mm"
                                          popperPlacement="bottom"
                                          locale="de"
                                       />
                                    </Form.Group>
                                    <button
                                       title="heute und jetzt als Datum einstellen"
                                       className="now-button"
                                       type="button"
                                       onClick={(e) =>
                                          setEskDaten((prev) => ({
                                             ...prev,
                                             kachel_max_eskalation: new Date(),
                                          }))
                                       }
                                    >
                                       {"˅"}
                                    </button>
                                 </div>
                              )}
                           </Row>
                           <Row>
                              <Form.Group as={Col} controlId={"id_am"} className="mb-3">
                                 <Form.Label>Zu bearbeitende Kacheln</Form.Label>
                                 <div className="multi-select flex-row">
                                    {datenblattkacheln &&
                                       Object.keys(datenanforderKacheln)
                                          .sort()
                                          .map((item) => {
                                             let mykachel;
                                             if (datenblattkacheln[projektstufe].kachel.length) {
                                                mykachel = datenblattkacheln[projektstufe].kachel.find(
                                                   (kachelitem) => kachelitem.kachelId === item
                                                );
                                             }
                                             if (
                                                eskstatus["kachel_status_" + item] &&
                                                eskstatus["kachel_status_" + item] === 4
                                             ) {
                                                mykachel = false;
                                             }

                                             if (mykachel) {
                                                return (
                                                   <div
                                                   key={"stapelkachel_"+item}
                                                      title={mykachel.heading}
                                                      className={
                                                         "multi-select-option" +
                                                         (selectedKacheln[item] ? " multi-selected" : "")
                                                      }
                                                      onClick={() =>
                                                         setSelectedKacheln((prev) => ({
                                                            ...prev,
                                                            [item]: prev[item] ? false : datenanforderKacheln[item],
                                                         }))
                                                      }
                                                   >
                                                      {mykachel.heading}
                                                   </div>
                                                );
                                             }
                                          })}
                                 </div>
                              </Form.Group>
                           </Row>
                        </div>
                        <div className="d-flex justify-content-end mt-2">
                           {isEdited ? (
                              <>
                                 <Button
                                    variant="danger"
                                    className="ms-1"
                                    onClick={() => {
                                       resetData();
                                       setIsEdited(false);
                                       setStapeldaten({});
                                       setEskDaten({});
                                       setSelectedKacheln({});
                                    }}
                                 >
                                    Änderungen zurücksetzen
                                 </Button>

                                 <Button
                                    className="ms-1 abschluss-button"
                                    onClick={() => {
                                       sendData({});
                                       setIsEdited(false);

                                       setStapeldaten({});
                                       setEskDaten({});
                                       setSelectedKacheln({});
                                    }}
                                 >
                                    Änderungen speichern
                                 </Button>
                              </>
                           ) : (
                              <Button
                                 variant="warning"
                                 // style={{ backgroundColor: "#b00" }}
                                 onClick={() => {
                                    editMultipleKachel(stapeldaten, eskDaten, selectedKacheln);
                                    setIsEdited(true);
                                 }}
                              >
                                 Änderungen in ausgewählte Kacheln schreiben
                              </Button>
                           )}
                        </div>
                     </Form>
                  </div>
               </Accordion.Body>
            </Accordion.Item>
         </Accordion>
      </>
   );
}
